import type { TaskPriority } from '../../../shared/lib/datetime';
import type {
  ChecklistItemEntity,
  CompletionEntity,
  ProjectEntity,
  TagEntity,
  TaskEntity,
  TaskTagEntity,
} from '../../../entities/task/model/task.types';

export type TaskListKind = 'today' | 'tomorrow' | 'overdue' | 'archive';

export interface TaskListItem {
  task: TaskEntity;
  tags: TagEntity[];
  checklistDone: number;
  checklistTotal: number;
  /** Дата видимости в списке (для повторяющихся — occurrence). */
  occurrenceDate: string | null;
  isCompleted: boolean;
  isRecurring: boolean;
  hasDescription: boolean;
  hasChecklist: boolean;
  hasTime: boolean;
}

export interface TaskFilters {
  tagIds: string[];
  priority: TaskPriority | 'all';
  search: string;
  hideCompleted: boolean;
  /** Один проект (не массив) — null = «Все проекты». */
  projectId: string | null;
}

export const EMPTY_TASK_FILTERS: TaskFilters = {
  tagIds: [],
  priority: 'all',
  search: '',
  hideCompleted: false,
  projectId: null,
};

export interface TasksData {
  tasks: TaskEntity[];
  tags: TagEntity[];
  projects: ProjectEntity[];
  checklistItems: ChecklistItemEntity[];
  taskTags: TaskTagEntity[];
  completions: CompletionEntity[];
}

export const EMPTY_TASKS_DATA: TasksData = {
  tasks: [],
  tags: [],
  projects: [],
  checklistItems: [],
  taskTags: [],
  completions: [],
};

/** null или undefined = живая запись (старые данные без поля). */
export function isTaskAlive(task: TaskEntity): boolean {
  return task.deleted_at == null;
}

export function isTagAlive(tag: TagEntity): boolean {
  return tag.deleted_at == null;
}

export function isProjectAlive(project: ProjectEntity): boolean {
  return project.deleted_at == null;
}

export function isLinkAlive(link: TaskTagEntity): boolean {
  return link.deleted_at == null;
}

export function isCompletionAlive(completion: CompletionEntity): boolean {
  return completion.deleted_at == null;
}

export function hasRecurrence(task: TaskEntity): boolean {
  return task.recurrence_rule !== null && task.recurrence_rule.trim().length > 0;
}

export function hasDescription(task: TaskEntity): boolean {
  return task.description.trim().length > 0;
}

/** Идея: is_idea=true, не архив. */
export function isIdea(task: TaskEntity): boolean {
  return task.is_idea === true;
}

/** Обычная задача списков: не идея, не в архиве. */
export function isRegularTask(task: TaskEntity): boolean {
  return task.is_idea !== true && task.archived_at === null;
}
